/* eslint-disable react/display-name */

import React from "react";
import { MenuItemLink, useTranslate } from "react-admin";
import { useTheme } from "@mui/material/styles";

import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import DefaultIcon from "@mui/icons-material/ViewList";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import PeopleIcon from "@mui/icons-material/People";
import customRoutes from "../customRoutes";

const commonStyles = (theme: any) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    minWidth: 40,
  },
  rootItem: {
    paddingBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  borderTop: {
    paddingBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    borderTop: "#e0e0e0 solid 1px",
    whiteSpace: "normal",
  },
  borderBottom: {
    paddingBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(1.5),
    borderBottom: "#e0e0e0 solid 1px",
  },
});

type MyMenuItemProps = {
  onMenuClick: () => void;
  resource: any;
  sidebarOpen: boolean;
  inSubMenu: boolean;
  icon?: any;
  isBorderTop?: boolean;
  isBorderBottom?: boolean;
};

export const MyMenuItem = (props: MyMenuItemProps) => {
  const { inSubMenu, onMenuClick, resource, sidebarOpen, isBorderBottom, isBorderTop } = props;
  const translate = useTranslate();
  const theme = useTheme();
  const styles = commonStyles(theme);

  const rootClassNames = !sidebarOpen
    ? styles.rootItem
    : isBorderTop
    ? styles.borderTop
    : isBorderBottom
    ? styles.borderBottom
    : styles.rootItem;
  const sx = inSubMenu ? (sidebarOpen ? styles.nested : {}) : rootClassNames;
  const itemIcon = resource.icon ? <resource.icon /> : <DefaultIcon />;

  let name;
  if (!(resource.options && resource.options.label)) {
    name = translate(`resources.${resource.name}.name`);
    name = name.replace("事前契約", "").replace("現物契約", "");
  }
  const customRoute = customRoutes.find((route) => route.key === resource.name);

  return (
    <MenuItemLink
      key={resource.name}
      to={customRoute ? customRoute.path : `/${resource.name}`}
      primaryText={name}
      leftIcon={itemIcon}
      onClick={onMenuClick}
      sidebarIsOpen={sidebarOpen}
      sx={sx}
    />
  );
};

type SubMenuProps = {
  primaryText: string;
  resources: any[];
  sidebarOpen: boolean;
  onMenuClick: () => void;
  icon?: any;
};

export const SubMenu = (props: SubMenuProps) => {
  const { onMenuClick, primaryText, resources, sidebarOpen, icon } = props;

  const [collapsed, setOpen] = React.useState(false);
  const theme = useTheme();
  const styles = commonStyles(theme);

  const handleClick = () => {
    setOpen(!collapsed);
  };

  const groupIcon = icon ? <props.icon /> : <DefaultIcon />;
  return (
    <>
      <ListItem component="div" onClick={handleClick}>
        <ListItemIcon sx={styles.icon}>{groupIcon}</ListItemIcon>
        {sidebarOpen && <ListItemText primary={primaryText} />}
        {collapsed ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={collapsed} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {resources.map((res) => {
            return (
              <MyMenuItem
                key={res.name}
                onMenuClick={onMenuClick}
                resource={res}
                sidebarOpen={sidebarOpen}
                inSubMenu={true}
                icon={PeopleIcon}
              />
            );
          })}
        </List>
      </Collapse>
    </>
  );
};
